import { SocialLinkType } from "scmp-app/components/author/author-social-links/enums";

type SocialLink = Nullish<{
  readonly class: Nullish<string>;
  readonly url: Nullish<string>;
}>;

export const getSocialLinkSchema = (socialLinks: Nullish<ReadonlyArray<SocialLink>>) => {
  let email: string | undefined;
  const sameAs: string[] = [];

  for (const socialLink of socialLinks ?? []) {
    const url = socialLink?.url?.trim();
    if (!url) continue;

    if (socialLink?.class === SocialLinkType.Email) {
      email = url.replace(/^mailto:/i, "").trim() || email;
    } else {
      sameAs.push(url);
    }
  }

  return { email, sameAs };
};
